import { Component } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { SharedModule } from './shared/shared.module';
import { MainContainerComponent } from './core/components/main-container/main-container.component';


@Component({
  selector: 'ngb-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [
    SharedModule,
    MainContainerComponent
  ],
})

export class AppComponent {
    
  title = 'generic-booking-fe';

  constructor(private dateAdapter: DateAdapter<Date>) {
    this.dateAdapter.setLocale('it'); 
  }

}

    
